import { render, staticRenderFns } from "./AuthMethod.vue?vue&type=template&id=52c4ed71"
import script from "./AuthMethod.vue?vue&type=script&lang=js"
export * from "./AuthMethod.vue?vue&type=script&lang=js"
import style0 from "./AuthMethod.vue?vue&type=style&index=0&id=52c4ed71&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports